export default "__VITE_ASSET__xY5qR3wZ__"